import { Link } from 'react-router-dom';

import { CardContainer } from './CardStyles';

const CardServico = ({ link, id, qtdCards, img, title, bgColor, txtColor }) => {

    return (
        <CardContainer qtdCards={qtdCards} bgColor={bgColor} txtColor = {txtColor}>
            <Link to={link} state={{ id: id }} />
            <div className='rect'></div>
            <img src={img} alt={title} />
            <h3>{title}</h3>
            
        </CardContainer>
    )
}

export default CardServico;